// extracted by mini-css-extract-plugin
export var box = "Auther-module--box--fdRVz";
export var image = "Auther-module--image--2Cs-X";
export var name = "Auther-module--name--3aB0y";